import cx from 'classnames';
import styles from './container.module.css';

const ContainerComponent = ({ className, ...otherProps }) => {
  return (
    <div
      className={cx('container', styles.container, className)}
      {...otherProps}
    />
  );
};

export default ContainerComponent;
